exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".style__container___3_gK4{font-family:Poppins-Light;font-size:14px;list-style-type:none}.style__page___3Us5w{display:inline;margin:5px;padding:20px}.style__page___3Us5w a,.style__page___3Us5w a:hover{color:#c9877d;cursor:pointer}.style__previous___3B1tY{margin-right:30px}.style__next___2gwW_,.style__previous___3B1tY{display:inline;letter-spacing:.5px;color:#333;cursor:pointer}.style__next___2gwW_{margin-left:30px}.style__active___2jGrr a{color:#4a4a4a;font-weight:700;cursor:auto}.style__disabled___1onov a{color:#ccc;cursor:not-allowed}.style__disabled___1onov a:hover{text-decoration:none}", ""]);

// exports
exports.locals = {
	"container": "style__container___3_gK4",
	"page": "style__page___3Us5w",
	"previous": "style__previous___3B1tY",
	"next": "style__next___2gwW_",
	"active": "style__active___2jGrr",
	"disabled": "style__disabled___1onov"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[name]__[local]___[hash:base64:5]!./src/components/paginator/style.css
// module id = 705
// module chunks = 0